export const putIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
